// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonTag_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 4C9.55229 4 10 3.55228 10 3C10 2.44772 9.55229 2 9 2C8.44771 2 8 2.44772 8 3C8 3.55228 8.44771 4 9 4Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.4 0.266666L10.4 0L12 1.6L11.7333 5.6L5.33333 12L0 6.66667L6.4 0.266666ZM10.0138 1.02797L10.972 1.98624L10.7605 5.15858L5.33333 10.5858L1.41421 6.66667L6.84142 1.23946L10.0138 1.02797Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.6967 5.30367C11.0872 5.6942 11.7204 5.6942 12.1109 5.30367C12.5014 4.91315 12.5014 4.27998 12.1109 3.88946C11.7204 3.49893 11.0872 3.49893 10.6967 3.88946C10.3062 4.27998 10.3062 4.91315 10.6967 5.30367Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8787 0L16 2.12132L15.6464 7.42462L7.16116 15.9099L0.0900879 8.83883L8.57537 0.353553L13.8787 0ZM13.9441 2.89381L13.7009 6.54178L7.16116 13.0815L2.91852 8.83883L9.45821 2.29914L13.1062 2.05594L13.9441 2.89381Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.3825 6.65662C18.7731 6.2661 18.7731 5.63294 18.3825 5.24241C17.992 4.85189 17.3588 4.85188 16.9683 5.24241C16.5778 5.63294 16.5778 6.2661 16.9683 6.65662C17.3588 7.04715 17.992 7.04715 18.3825 6.65662Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13.7282L12.7272 1.00098L12.7286 1.00098H21.2125L22.6267 2.41519V10.9005L9.89949 23.6277L0 13.7282ZM13.435 3.12161L20.5058 3.12186L20.5061 10.1927L9.8995 20.7993L2.82843 13.7282L13.435 3.12161Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8534 3.65269L27.8047 3.05594L29.3497 4.60092L28.7529 13.5522L13.7279 28.5772L3.82843 18.6777L18.8534 3.65269ZM28.5772 1L31.4056 3.82843L30.6985 14.435L13.7279 31.4056L1 18.6777L17.9706 1.70711L28.5772 1ZM22.9203 9.48528C23.7014 10.2663 24.9677 10.2663 25.7487 9.48528C26.5298 8.70423 26.5298 7.4379 25.7487 6.65685C24.9677 5.87581 23.7014 5.87581 22.9203 6.65685C22.1393 7.4379 22.1393 8.70423 22.9203 9.48528Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonTag is a generated icon component.
 */
let IconCommonTag = IconCommonTag_1 = class IconCommonTag extends IconBaseElement {
    render() {
        return html `${IconCommonTag_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonTag.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonTag = IconCommonTag_1 = __decorate([
    customElement('zui-icon-common-tag')
], IconCommonTag);
export { IconCommonTag };
